import { registerLocaleData } from '@angular/common';

import localeEnGb from '@angular/common/locales/en-GB';
import localeDe from '@angular/common/locales/de'; // also de-DE


registerLocaleData(localeEnGb, 'en-GB');
registerLocaleData(localeDe, 'de');

// -------------------------------------------------------------------
// Custom formatting registrations
// -------------------------------------------------------------------

import { registerCustomLocaleData } from '@vwd/ngx-i18n';

import customLocaleEnGb from '@vwd/ngx-i18n/locales/en-GB';
import customLocaleDe from '@vwd/ngx-i18n/locales/de';


registerCustomLocaleData(customLocaleEnGb, 'en-GB');
registerCustomLocaleData(customLocaleDe, 'de');


// -------------------------------------------------------------------
// PrimeNG registrations
// -------------------------------------------------------------------
import { registerPrimeNgLocaleData } from '@vwd/ngx-i18n/primeng';
import primeNgLocaleDe from '@vwd/ngx-i18n/primeng/locales/de';

registerPrimeNgLocaleData(primeNgLocaleDe, 'de');


// -------------------------------------------------------------------
// Moment registrations
// -------------------------------------------------------------------

import 'moment';
import 'moment/locale/en-gb.js';
import 'moment/locale/de.js';


